module.exports = __webpack_public_path__ + "static/media/Retract_Access.50d30de5.png";